/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { put } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createSocketChannel } from './channels/socket-channel';
import cfg from '../config';

function* processMessage(action: any) {
  if (action.events && action.events.length > 0) {
    yield put({ type: AT.WS_MESSAGE_ENTRY_ADDED, ...action });
  }
}

let messageTrackerWS: any;

function* startTracker() {
  messageTrackerWS = new window.WebSocket(
    `${cfg.socketHost}/message-tracker/v1`
  );
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const ch = yield createSocketChannel(messageTrackerWS);
  yield takeEvery(ch, processMessage);
}

function stopTracker() {
  if (messageTrackerWS) {
    try {
      messageTrackerWS.close();
      messageTrackerWS = null;
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

function* processCommand(action: any) {
  const command = action.command || 'start';
  switch (command) {
    case 'stop': {
      yield stopTracker();
      break;
    }
    default: {
      stopTracker();
      yield startTracker();
    }
  }
}

export function* messageTrackerSaga() {
  yield takeLatest(AT.MESSAGE_TRACKER_SAGA, processCommand);
}
